export enum BuildVehicleSelects {
    inventoryType = 'inventoryType',
    year = 'year',
    make = 'make',
    model = 'model',
    trim = 'trim'
}

export enum InventoryType {
    NEW = 'New',
    USED = 'Used',
    CERTIFIED = 'CPO'
}

export enum InventoryTypeFilters {
    NEW = 'NEW',
    USED = 'USED',
    CERTIFIED = 'CERTIFIED',
    OTHER = 'OTHER'
}

export type BuildVehicleInitValue = {
    vin?: string;
    year: string;
    make: string;
    model: string;
    trim: string;
    inventoryType?: string;
};

export type YMMTSelects = Exclude<BuildVehicleSelects, BuildVehicleSelects.inventoryType>;

export const selectOrder = [
    BuildVehicleSelects.inventoryType,
    BuildVehicleSelects.year,
    BuildVehicleSelects.make,
    BuildVehicleSelects.model,
    BuildVehicleSelects.trim
] as const;

export const inventoryTypeOptions = [InventoryType.NEW, InventoryType.USED, InventoryType.CERTIFIED];
export const selectLabels = {
    [BuildVehicleSelects.inventoryType]: 'Inventory Type',
    [BuildVehicleSelects.year]: 'Year',
    [BuildVehicleSelects.make]: 'Make',
    [BuildVehicleSelects.model]: 'Model',
    [BuildVehicleSelects.trim]: 'Trim'
};

export const inventoryTypeToVehicleConditionMap = {
    [InventoryType.NEW]: 'new',
    [InventoryType.USED]: 'used',
    [InventoryType.CERTIFIED]: 'certified'
};
